<div
	class="sdp-footer-container"
	[class.gt-sm]="{'sdp-footer-container-lg' : true}"
	[class.lt-mat]="{'sdp-footer-container-sm' : true}"
>
	<span
		[innerHtml]="footerMessage"
		class="sdp-footer-span"
	></span>
</div>